module.exports = __webpack_public_path__ + "img/FamilyHeader.ee823777.jpg";